<div class="row mt-2 no-gutters">
  <div class="col">
    <small (click)="showSearchResult = false"><a [routerLink]="['/service-provider/dashboard']" class="text-secondary">Admin Console</a></small>
    <small *ngIf="showSearchResult">
      <a class="text-secondary pointer" (click)="onNavSearchClick();"> &nbsp;/ Search</a>
      <a *ngIf="selectedSearchItemForView" class="text-secondary"> / {{selectedSearchItemForView}}</a>
    </small>
  </div>
</div>

<div *ngIf="showSearchResult" class="row align-items-center justify-content-center no-gutters">
  <div class="col-12">
    <app-search-results [locationList]="searchedLocationList" [servicePackageList]="searchedServicePackageList"
      [vehicleList]="searchedVehicleList" (selectedItemEmitter)="onSearchItemDetail($event);"
      (selectedItemCloseEmitter)="selectedSearchItemForView=null;" #searchResult></app-search-results>
  </div>
</div>

<div *ngIf="!showSearchResult" class="row align-items-center justify-content-center home-container no-gutters">
  <div class="col pl-0 pr-0">
    <div *ngIf="authService.isAdmin()" class="row text-center ml-1 mr-1 mt-4">
      <div *ngFor="let option of authService.navigationOptions" class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid  icon" src="{{option.imageSource}}" alt="{{option.alt}}"
          routerLink="{{option.route}}" /><br>
        <span class="font-nissan-brand-w01-bold font-14">{{option.label}}</span><br>
        <span class="font-nissan-brand-w01-light font-12">{{option.description}}</span>
      </div> 
    </div>
    <div *ngIf="authService.isDeveloper()" class="row text-center ml-1 mr-1 mt-4 no-gutters">
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid icon" src="assets/images/developer-access.png" alt="Developer Access"
          (click)="apiAccess.openDeveloperAccess()" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Developer Access</span><br>
        <span class="font-nissan-brand-w01-light font-12">View and manage API access</span>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid icon" src="assets/images/developer-access.png" alt="Swagger"
          routerLink="/swagger-ui"/><br>
        <span class="font-nissan-brand-w01-bold font-14">Developer APIs</span><br>
        <span class="font-nissan-brand-w01-light font-12">View and try APIs</span>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid icon" src="assets/images/question.png" alt="Support" routerLink="/support" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Support</span><br>
        <span class="font-nissan-brand-w01-light font-12">Access support services</span>
      </div>
    </div>
    <div *ngIf="authService.isFinanceAdmin()" class="row text-center ml-1 mr-1 mt-4 no-gutters">
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid icon" src="assets/images/usage.png" alt="invoices" routerLink="/invoices" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Invoices</span><br>
        <span class="font-nissan-brand-w01-light font-12">View invoices</span>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid icon" src="assets/images/question.png" alt="Support" routerLink="/support" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Support</span><br>
        <span class="font-nissan-brand-w01-light font-12">Access support services</span>
      </div>
    </div>
  </div>
</div>

<ncc-tnc></ncc-tnc>

<!-- Modal API Access -->
<developer-access #apiAccess></developer-access>